import React, { useEffect, useImperativeHandle } from 'react'

import { IActionComponentAPI, IActionComponentProps, IActionSubmitResponse } from '../types'

import useSession from '../../session/useSession'
import useViewport from '../../modules/viewport/useViewport'
import ErrorView from './View'

import style from './style.module.scss'

const ErrorAction = React.memo(
  React.forwardRef<IActionComponentAPI, IActionComponentProps>(({ action }, ref) => {
    const session = useSession()
    const viewport = useViewport()
    useEffect(() => {
      session.setWidgetWidth(null)
      session.enableNavigation(false)
      session.progress.updateFromAction(action)
      session.currentTarget = null
    }, [session, action])

    useImperativeHandle<IActionComponentAPI, IActionComponentAPI>(ref, () => {
      return {
        tryNext() {
          return true
        },
        tryPrev() {
          return false
        },
        showValidation() {
          //
        },
        get submitResponse() {
          const submitResponse: IActionSubmitResponse[] = []
          return submitResponse
        },
        get currentQuestionModel(): null {
          return null
        }
      }
    }, [])

    return (
      <div className={`${style.ErrorAction} ${style.action} ${viewport.mobile ? style.mobile : ''}`}>
        <ErrorView action={action} />
      </div>
    )
  }),
  (prevProps, nextProps) => prevProps.action === nextProps.action
)

ErrorAction.displayName = 'ErrorAction'

export default ErrorAction
